// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".common-cls1__b3033d0007d3ef42e65e{/*!*/}.common-cls2___5adfa80661e2e8df6ad{display:flex;align-items:center;font-size:24px;padding:18px 24px;margin-right:-18px;color:#91919e;cursor:pointer}.common-cls2___5adfa80661e2e8df6ad:hover{color:#ccc}@media(max-width: 991px){.common-cls2___5adfa80661e2e8df6ad{position:absolute;top:10px;right:0;margin-right:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "common-cls1__b3033d0007d3ef42e65e",
	"cls2": "common-cls2___5adfa80661e2e8df6ad common-cls1__b3033d0007d3ef42e65e"
};
export default ___CSS_LOADER_EXPORT___;
